
import React from 'react';
import { Button } from '@/components/ui/button';
import { Edit, Trash2 } from 'lucide-react';
import { TeacherAvailabilityTemplate } from '@/types/teacherAvailability';

interface TimeSlotCardProps {
  slot: TeacherAvailabilityTemplate;
  dayOfWeek: number;
  onEdit: (dayOfWeek: number, slot: TeacherAvailabilityTemplate) => void;
  onDelete: (slotId: string, dayOfWeek: number, slot: TeacherAvailabilityTemplate) => void;
}

export function TimeSlotCard({ slot, dayOfWeek, onEdit, onDelete }: TimeSlotCardProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 bg-gray-50 p-3 rounded-lg">
      <div className="flex items-center justify-center sm:justify-start">
        <span className="text-sm text-center sm:text-left">
          {slot.start_time} - {slot.end_time}
        </span>
      </div>
      <div className="flex gap-2 justify-center sm:justify-end">
        <Button 
          size="sm" 
          variant="outline" 
          onClick={() => onEdit(dayOfWeek, slot)}
          className="flex items-center gap-1 text-xs px-2 py-1 h-7"
        >
          <Edit size={12} />
          <span className="hidden xs:inline">แก้ไข</span>
        </Button>
        <Button 
          size="sm" 
          variant="destructive" 
          onClick={() => onDelete(slot.id, dayOfWeek, slot)}
          className="flex items-center gap-1 text-xs px-2 py-1 h-7"
        >
          <Trash2 size={12} />
          <span className="hidden xs:inline">ลบ</span>
        </Button>
      </div>
    </div>
  );
}
